import styled from 'styled-components';

const StyledContainer = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-left: 64px;
`;

export default StyledContainer;
